export const elias = {
  authorName: 'Elias A.',
  authorAvatarUrl: '/blog/avatar_elias.webp',
}

export const lena = {
  authorName: 'Lena P.',
  authorAvatarUrl: '/blog/avatar_lena.webp',
}

export const vanessa = {
  authorName: 'Vanessa L.',
  authorAvatarUrl: '/blog/avatar_vanessa.webp',
}
